import { FileReaderBase } from './file-reader-base';

export class XmlReaderProps extends FileReaderBase {
	//A place holder class for the XML Reader props
	constructor(init?: Partial<XmlReaderProps>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
